window.dataLayer = window.dataLayer || [];

const addToDataLayer = shape => {
  window.dataLayer.push(shape);
};

const useTracking = () => addToDataLayer;

export const virtualPageViewTracking = (
  postTags,
  categories,
  rootLevel,
  currentTitle,
  parents,
) => {
  const tagnames = postTags ? postTags.map(({ name }) => name) : 'No tags';
  const categorynames = categories
    ? categories?.map(({ name }) => name)
    : 'No categories';

  const parentList = parents ? parents.map(parent => parent.slug) : [];

  const breadcrumb = [
    ...new Set([rootLevel.slug, ...parentList, currentTitle.toLowerCase()]),
  ];

  const area = breadcrumb[0] === 'startseite' ? 'privat' : breadcrumb[0];

  addToDataLayer({
    event: 'virtualPageView',
    title: document.title,
    url: `${document.location.pathname}${document.location.search}`,
    trackingtype: 'page-info',
    categorynames,
    tagnames,
    breadcrumb,
    area,
  });
};

export const trackInteraction = id => {
  const trimmed = id && id.trim();
  const validateInteractionId = value => /^(.+;.+;.+;.+)$/.test(value);

  if (!trimmed || !validateInteractionId(trimmed)) {
    return;
  }

  addToDataLayer({
    event: 'interactionInfo',
    interactionId: trimmed,
  });
};

export default useTracking;
